import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { TextValidator } from 'react-material-ui-form-validator';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { withRouter } from 'react-router-dom';
import { isPasswordsInvalid } from '../../util/isPasswordsInvalid';
import { withSnackbar } from 'notistack';
import CardForm from '../../components/CardForm';
import * as api from '../../services/api/auth';

class PasswordReset extends Component {
  state = {
    title: '',
    password: '',
    passwordConfirmation: '',
    buttonDisable: false,
    showPassword: false,
    showConfirmPassword: false,
  };

  componentDidMount() {
    const { reason } = this.props.match.params;
    if (reason === 'expired') {
      this.setState({
        ...this.state,
        title: 'Your password has expired, please choose a new one',
      });
    } else if (reason === 'forgot') {
      this.setState({ ...this.state, title: 'Set your new password' });
    }
    const { resetToken } = this.props.match.params;
    if (!resetToken) {
      window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    }
  }

  handlePasswordChange = event => {
    this.setState({ password: event.target.value });
  };

  handlePasswordConfirmationChange = event => {
    this.setState({ passwordConfirmation: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };

  handleClickShowConfirmPassword = () => {
    this.setState((prev) => ({ showConfirmPassword: !prev.showConfirmPassword }));
  };
  
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleSubmit = async () => {
    const { history, enqueueSnackbar } = this.props;
    const { password, passwordConfirmation, title } = this.state;
    const { resetToken } = this.props.match.params;
    // const { location } = props;
    //  const queryParams = queryString.parse(location.search);
    // console.log('queryParams',this.props)
    this.setState({
      buttonDisable: true,
    });
    const invalidPasswordReason = isPasswordsInvalid(
      password,
      passwordConfirmation
    );
    if (invalidPasswordReason) {
      alert(invalidPasswordReason);
      this.setState({
        buttonDisable: false,
      });
    } else {
      const updatePasswordResponse = await api.updatePassword({
        password,
        resetToken,
      });
      if (
        updatePasswordResponse.data === 'Password should not same with previous'
      ) {
        this.setState({
          buttonDisable: false,
        });
        enqueueSnackbar('Password should not same with previous password', {
          variant: 'warning',
          preventDuplicate: true,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        });
      } else if (updatePasswordResponse.data.message === 'jwt expired') {
        this.setState({
          buttonDisable: false,
        });
        enqueueSnackbar('Session token expired. Try again', {
          variant: 'error',
          autoHideDuration: 3000,
          preventDuplicate: true,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        });
        if (this.props.match.params.reason === 'forgot') {
          history.push('/password-reset');
        } else {
          history.push('/login');
        }
      } else {
        this.setState({
          buttonDisable: false,
        });
        history.push('/password-reset/reset/confirmation');
      }
    }
  };

  render() {
    const { password, passwordConfirmation, buttonDisable } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <CardForm
          headerText={this.state.title}
          errorText="New password failed. Please try again."
          submitText="Update Password"
          onSubmit={this.handleSubmit}
          buttonDisable={buttonDisable}
        >
          <>
            <Grid item xs={12} className={classes.formControl}>
              <TextValidator
                fullWidth
                type={this.state.showPassword ? 'text' : 'password'}
                label="Password"
                value={password}
                variant="outlined"
                onChange={this.handlePasswordChange}
                validators={['required']}
                errorMessages={['Required']}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                        edge="end"
                      >
                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} className={classes.formControl}>
              <TextValidator
                fullWidth
                type={this.state.showConfirmPassword ? 'text' : 'password'}
                label="Password Confirmation"
                value={passwordConfirmation}
                variant="outlined"
                onChange={this.handlePasswordConfirmationChange}
                validators={['required']}
                errorMessages={['Required']}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={this.handleClickShowConfirmPassword}
                        onMouseDown={this.handleMouseDownPassword}
                        edge="end"
                      >
                        {this.state.showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </>
        </CardForm>
      </div>
    );
  }
}

const styles = () => ({
  root: {},
  formControl: {
    marginBottom: '24px',
  },
});

export default withSnackbar(withRouter(withStyles(styles)(PasswordReset)));
